import { useLayoutEffect, useRef, useState } from "react";
import "./Tooltip.scss";

export const Tooltip = ({ children, label, defaultPosition = "top" }) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState(defaultPosition);

  const triggerRef = useRef(null);
  const contentRef = useRef(null);

  useLayoutEffect(() => {
    if (!visible || !triggerRef.current || !contentRef.current) return;

    const triggerRect = triggerRef.current.getBoundingClientRect();
    const tooltipHeight = contentRef.current.offsetHeight;
    const spacing = 8;

    const spaceTop = triggerRect.top;
    const spaceBottom = window.innerHeight - triggerRect.bottom;

    if (defaultPosition === "top" && spaceTop < tooltipHeight + spacing && spaceBottom > spaceTop) {
      setPosition("bottom");
      return;
    }

    if (defaultPosition === "bottom" && spaceBottom < tooltipHeight + spacing && spaceTop > spaceBottom) {
      setPosition("top");
      return;
    }

    setPosition(defaultPosition);
  }, [visible, defaultPosition]);

  return (
    <div
      className="tooltip"
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
      ref={triggerRef}
    >
      <div className="tooltip__trigger">
        {children}
      </div>
      {visible && (
        <div
          className={`tooltip__content tooltip__content--${position}`}
          ref={contentRef}
        >
          {label}
        </div>
      )}
    </div>
  );
};
